import { render, staticRenderFns } from "./text-span.vue?vue&type=template&id=5d00186a"
import script from "./text-span.vue?vue&type=script&lang=js"
export * from "./text-span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports